export enum ImporterName {
  Colorado = 'colorado',
  EmployeeMasterData = 'employee-md',
  EquityValues = 'equity-values',
  BenchmarkData = 'benchmark-data',
  OrganisationPlanning = 'organisation-planning',
  OrgPlanningCorrection = 'org-planning-correction',
  OrganisationEmployees = 'organisation-employees',
  SeasonOrganisationPlanning = 'season-organisation-planning',
  SeasonOrganisationInformation = 'season-organisation-information',
  OrganisationInformation = 'organisation-information',
  SeasonPositionSnapshots = 'season-position-snapshots',
  MercerJobCode = 'mjl',
  MeritSimulationMemberTags = 'merit-simulation-member-tags',
  MidYearIncreases = 'mid-year-increases',
  MeritEmployeeData = 'merit-employee-data',
  EclEmployee = 'ecl-employees',
  EclEmployeeAttributes = 'ecl-employee-attributes',
  CountryPayGapData = 'country-pay-gap-data',
  EmployeePayGapData = 'employee-pay-gap-data',
  MultiplierDifferentiationData = 'multiplier-differentiation-data',
  IncentiveTiaData = 'incentive-tia-data',
  RestructuringEmployeeData = 'restructuring-employee-data',
  RestructuringEmployeeSnapshotData = 'restructuring-employee-snapshot-data',
  SeKeyExperts = 'se-key-experts',
  PositionRequestBulkOrgCodeTransfer = 'position-request-bulk-org-code-transfer',
  PersonalBusinessPartners = 'personal-business-partners'
}
